import { MainLayout, ErrorLayout } from '../main_layout.js';

export class Page {
  static layout = MainLayout;
  static javascript() {}
  static css = "";
  static authAccess = 'protected';
}

export class PublicPage {
  static layout = MainLayout;
  static javascript() {}
  static css = "";
  static authAccess = 'public';
}

export class SharedPage {
  static layout = MainLayout;
  static javascript() {}
  static css = "";
  static authAccess = 'shared';
}

export class Error404 extends PublicPage {
  static layout = ErrorLayout;
  static authAccess = 'public';
  static timl = `
    div
      h1 404 Not Found
      div
        p You've somehow ended up on a URL that doesn't exist.
  `;
}

globalThis.Error404 = Error404;
